module.exports = __webpack_public_path__ + "static/media/frame.58860e86.png";